import { createSelector } from 'reselect';

export interface RegionsState {
  loading: boolean;
  regions: any[];
  error: string;
}

export const initialState: RegionsState = {
  loading: false,
  regions: [],
  error: '',
};

const getRegions = ({ regions }: any): RegionsState => regions;

export const regionsSelectors = {
  getRegions: createSelector(
    [getRegions],
    ({ regions }) => regions,
  ),

  getLoading: createSelector(
    getRegions,
    ({ loading }) => loading,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Regions/services/selectors.ts